"use client"

import {
    Box,
    Button,
    Container,
    Grid,
    Typography,
    Card,
    CardContent,
    CardMedia,
    Checkbox,
    FormControlLabel,
    FormGroup,
    Chip,
    IconButton,
    TableRow,
    TableCell,
    TableBody,
    Table,
    Radio,
    RadioGroup,
    CircularProgress,
} from "@mui/material"
import { Visibility, Code, Share, ContentCopy, Instagram, Facebook } from "@mui/icons-material"
import { useEffect, useState } from "react"
import { Images } from "../../../assests"
import { useLocation, useNavigate } from "react-router-dom"

import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // important
import { currencyType } from "../../../utils"
import OrderServices from "../../../services/OrderServices"
import { Helmet } from "react-helmet"


const dummyMerchants = [
    {
        id: 1,
        name: "UrbanStitch",
        description: "UrbanStitch is your go-to destination...",
        state: "California",
        city: "Los Angeles",
        standard: {
            oneSide: "$20",
            doubleSide: "$40",
            additional: "$20",
        },
        premium: {
            oneSide: "$50",
            doubleSide: "$80",
            additional: "$20",
        },
    },

]
const platformIcons = {
    facebook: <FacebookIcon sx={{ color: "white", fontSize: '32px' }} />,
    instagram: <InstagramIcon sx={{ color: "white", fontSize: '32px' }} />,
    twitter: <TwitterIcon sx={{ color: "white", fontSize: '32px' }} />,
    linkedin: <LinkedInIcon sx={{ color: "white", fontSize: '32px' }} />,
};
const dummyVendors = [
    {
        id: 1,
        name: "PremiumFit",
        description:
            "UrbanStitch is your go-to destination for stylish, high-quality t-shirts crafted with comfort and individuality in mind",
        state: "California",
        city: "Los Angeles",
        images: [
            "/standard-shirt1.png",
            "/standard-shirt2.png",
            "/premium-shirt1.png",
            "/premium-shirt2.png",
            "/premium-shirt3.png",
        ],
        standardPrice: {
            oneSide: "$20",
            doubleSide: "$40",
            additional: "$20",
            standardTag: "$25",
        },
        premiumPrice: {
            oneSide: "$50",
            doubleSide: "$80",
            additional: "$20",
            premiumTag: "$50",
        },
    },
]
const fabricOptions = [
    "Polyester",
    "Cotton",
    "Linen",
    "Organic Cotton",
    "Combed Cotton",
    "Modal",
    "Hemp",
    "Lycra",
    "Ringspun Cotton",
    "Nylon",
    "Rayon/Bamboo Viscose",
    "Poly",
    "Flannel",
    "Pima Cotton",
    "Bulk Cotton",
    "Spandex",
    "Sustainability",
    "Fleece Fabric",
]

const MerchantDetail = () => {
    const [selectedFabrics, setSelectedFabrics] = useState([])
    const navigate = useNavigate()
    const [vendors] = useState(dummyVendors)
    const { state } = useLocation()
    const [selectedFabric, setSelectedFabric] = useState(null)


    const handleImageLoad = (index) => {
        setLoaded((prev) => {
            const updated = [...prev];
            updated[index] = true;
            return updated;
        });
    };
    const handleFabricChange = (fabric) => {
        setSelectedFabrics((prev) => (prev.includes(fabric) ? prev.filter((f) => f !== fabric) : [...prev, fabric]))
    }
    console.log(state, 'statestate');
    const images = state?.merchant?.products?.[0]?.sample_images || [];
    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [loaded, setLoaded] = useState(images.map(() => false));
    const UpdateCart = async (vendor, fabric) => {

        console.log(vendor, 'vendorvendorvendor');




        try {
            let obj = {


                vendor_id: vendor?._id,
                product_id: vendor?.products[0]?._id,
                fabric: selectedFabric

            }

            const { message } = await OrderServices.UpdateCart(obj)


        } catch (error) {
            console.log(error);
        } finally {
            navigate("/checkout");
        }



    }

    useEffect(() => {
        console.log(state?.merchant, 'state?.merchant?.products[0]?.standard_fabrics[0]');

        if (state?.merchant?.products?.length > 0 && state?.merchant?.products[0]?.fabrics?.length > 0) {

            setSelectedFabric(state?.merchant?.products[0]?.fabrics[0])
        }


    }, [state])

    return (
        <div>
           
            <Box
                sx={{
                    backgroundImage: `url("${Images.contactBg}")`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    width: "100%",
                    height: "300px", // Adjust height as needed
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                }}
            >
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                    <Typography
                        variant="h3"
                        className="banner-text heading-font"
                        sx={{
                            fontSize: "35px",
                            textAlign: "center",
                            fontFamily: "Noto Sans, sans-serif",
                            color: "white",
                            fontWeight: "bold",
                        }}
                    >
                        Merchant Details
                    </Typography>
                </Box>
            </Box>
            <Container maxWidth={"lg"} sx={{ my: 4 }}>

                <Grid container spacing={3}>

                    <Grid item xs={12} md={12}>

                        <Grid container spacing={3}>

                            <Grid item xs={12} >
                                <Card
                                    sx={{
                                        bgcolor: "#192133",
                                        color: "white",
                                        borderRadius: '14px',
                                        p: 3,
                                        boxShadow: 3,
                                    }}
                                >

                                    <Grid container spacing={5}>
                                        {/* LEFT SIDE (Info + Prices + Buttons) */}

                                        <Grid item xs={12} md={12} >
                                            {/* Description */}
                                            <Typography variant="h4" className="heading-font" sx={{ mb: 2, fontFamily: "Maven Pro, sans-serif", fontWeight: 'bold' }}>
                                                {state?.merchant?.name}
                                            </Typography>
<Grid
  container
  spacing={0}
  sx={{
    mb: 3,
    mt: 2,
    borderBottom:{ xs:'none',sm:"1px solid rgba(255,255,255,0.2)"},
  }}
>
  {[
    { label: "State", value: state?.merchant?.state },
    { label: "City", value: state?.merchant?.city },
    { label: "Email", value: state?.merchant?.email },
    { label: "Phone Number", value: state?.merchant?.phone },
  ].map((item, index) => (
    <Grid
      key={index}
      item
      xs={12}
      sm={6}
      md={3}
      sx={{
        p: 2,
        pb: 0,
        mb: 1,
        borderRight: {
          xs: "none",
             
          sm:
            (index + 1) % 2 === 0
              ? "none"
              : "1px solid rgba(255,255,255,0.2)", // every 2nd item in tablet has no right border
          md:
            index !== 3
              ? "1px solid rgba(255,255,255,0.2)"
              : "none", // only last column has no border on desktop
        },
        borderBottom: {
          xs:
             "1px solid rgba(255,255,255,0.2)",
              
          sm:
            index < 2
              ? "1px solid rgba(255,255,255,0.2)"
              : "none", // same for small tablets
          md: "none",
        },
      }}
    >
      <Typography
        variant="body2"
        sx={{ fontFamily: "Maven Pro, sans-serif" }}
      >
        <strong>{item.label}</strong>
      </Typography>
      <Typography
        variant="body2"
        sx={{ mt: 1, fontFamily: "Maven Pro, sans-serif" }}
      >
        {item.value}
      </Typography>
    </Grid>
  ))}
</Grid>


                                            {/* <Grid
                                                container
                                                spacing={0}
                                                sx={{
                                                    mb: 3,
                                                    mt: 2,
                                                    borderBottom: "1px solid rgba(255,255,255,0.2)", // full box border



                                                }}
                                            >
                                                <Grid
                                                    item
                                                    xs={2}
                                                    sx={{
                                                        borderRight: "1px solid rgba(255,255,255,0.2)",
                                                        p: 2,
                                                        mb: 1,
                                                        pb: 0
                                                    }}
                                                >
                                                    <Typography variant="body2" sx={{ fontFamily: "Maven Pro, sans-serif " }}>
                                                        <strong>Email</strong>
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ mt: 1, fontFamily: "Maven Pro, sans-serif ", wordBreak: 'break-word' }}>
                                                        {state?.merchant?.email}
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={4} sx={{ p: 2, pb: 0, pl: 6 }}>
                                                    <Typography variant="body2" sx={{ fontFamily: "Maven Pro, sans-serif " }}>
                                                        <strong>Phone Number</strong>
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ mt: 1, fontFamily: "Maven Pro, sans-serif " }}>
                                                        {state?.merchant?.phone}
                                                    </Typography>
                                                </Grid>
                                            </Grid> */}
                                            {/* <Grid
                                                container
                                                spacing={0}
                                                sx={{
                                                    mb: 3,
                                                    mt: 2,
                                                    borderBottom: "1px solid rgba(255,255,255,0.2)", // full box border
                                                }}
                                            >
                                               
                                                <Grid
                                                    item
                                                    xs={6}
                                                    sx={{
                                                        borderRight: "1px solid rgba(255,255,255,0.2)",
                                                        p: 2,
                                                        mb: 1,
                                                        pb: 0,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{ fontFamily: "Maven Pro, sans-serif " }}
                                                    >
                                                        <strong>Standard Fabrics</strong>
                                                    </Typography>

                                                    <Typography
                                                        variant="body2"
                                                        sx={{ mt: 1, fontFamily: "Maven Pro, sans-serif " }}
                                                    >
                                                        {state?.merchant?.products[0]?.fabrics?.length > 0 &&
                                                            state.merchant.products[0].fabrics
                                                                .map((fabric) => fabric?.name ?? fabric)
                                                                .join(", ")}
                                                    </Typography>
                                                </Grid>

                                            
                                                <Grid
                                                    item
                                                    xs={6}
                                                    sx={{
                                                        p: 2,
                                                        mb: 1,
                                                        pb: 0,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{ fontFamily: "Maven Pro, sans-serif " }}
                                                    >
                                                        <strong>Premium Fabrics</strong>
                                                    </Typography>

                                                    <Typography
                                                        variant="body2"
                                                        sx={{ mt: 1, fontFamily: "Maven Pro, sans-serif " }}
                                                    >
                                                        {state?.merchant?.products[0]?.premium_fabrics?.length > 0 &&
                                                            state.merchant.products[0].premium_fabrics
                                                                .map((fabric) => fabric?.name ?? fabric)
                                                                .join(", ")}
                                                    </Typography>
                                                </Grid>
                                            </Grid> */}
                                            <Grid container >
                                                {/* Standard Shipping */}
                                                <Grid item xs={12} md={4}>
                                                    <Box
                                                        sx={{
                                                            mb: 3,
                                                            borderBottom: "1px solid rgba(255,255,255,0.2)",
                                                            borderRight: {
                                                                xs: 'none',
                                                                sm: 'none',
                                                                md: state?.merchant?.shipping?.premium?.day ? '1px solid rgba(255,255,255,0.2)' : 'none',
                                                                lg: '1px solid rgba(255,255,255,0.2)',
                                                            },
                                                            pb: "10px",

                                                        }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            sx={{ mb: 1, fontFamily: "Maven Pro, sans-serif", m: 2, mb: 0 }}
                                                        >
                                                            <strong>Standard Shipping Price</strong>
                                                        </Typography>
                                                        <Grid container m={2} mb={0}>
                                                            <Grid
                                                                item
                                                                xs={4}
                                                                sx={{
                                                                    borderRight: "1px solid rgba(255,255,255,0.2)",
                                                                    pr: 2,
                                                                    fontFamily: "Maven Pro, sans-serif",
                                                                }}
                                                            >
                                                                <Typography variant="caption">Days</Typography>
                                                                <Typography variant="body2" mt={1.5}>
                                                                    {state?.merchant?.shipping?.standard?.days}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid
                                                                item
                                                                xs={4}
                                                                sx={{
                                                                    borderRight: "1px solid rgba(255,255,255,0.2)",
                                                                    px: 2,
                                                                }}
                                                            >
                                                                <Typography variant="caption">In City</Typography>
                                                                <Typography variant="body2" mt={1.5}>
                                                                    {currencyType[process.env.REACT_APP_CURRENCY]?.code}{" "}
                                                                    {state?.merchant?.shipping?.standard?.instate_price}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={4} sx={{ pl: 2 }}>
                                                                <Typography variant="caption">Out City</Typography>
                                                                <Typography variant="body2" mt={1.5}>
                                                                    {currencyType[process.env.REACT_APP_CURRENCY]?.code}{" "}
                                                                    {state?.merchant?.shipping?.standard?.outstate_price}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Grid>

                                                {/* Premium Shipping */}
                                                {state?.merchant?.shipping?.premium?.days && <Grid item xs={12} md={4}>
                                                    <Box
                                                        sx={{
                                                            mb: 3,
                                                            borderBottom: "1px solid rgba(255,255,255,0.2)",
                                                            borderRight: {
                                                                xs: 'none',
                                                                sm: 'none',
                                                                md: '1px solid rgba(255,255,255,0.2)',
                                                                lg: '1px solid rgba(255,255,255,0.2)',
                                                            },
                                                            pb: "10px",

                                                        }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            sx={{ mb: 1, fontFamily: "Maven Pro, sans-serif", m: 2, mb: 0 }}
                                                        >
                                                            <strong>Premium Shipping Price</strong>
                                                        </Typography>
                                                        <Grid container m={2} mb={0}>
                                                            <Grid
                                                                item
                                                                xs={4}
                                                                sx={{
                                                                    borderRight: "1px solid rgba(255,255,255,0.2)",
                                                                    pr: 2,
                                                                }}
                                                            >
                                                                <Typography variant="caption">Days</Typography>
                                                                <Typography variant="body2" mt={1.5}>
                                                                    {state?.merchant?.shipping?.premium?.days}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid
                                                                item
                                                                xs={4}
                                                                sx={{
                                                                    borderRight: "1px solid rgba(255,255,255,0.2)",
                                                                    px: 2,
                                                                }}
                                                            >
                                                                <Typography variant="caption">In City</Typography>
                                                                <Typography variant="body2" mt={1.5}>
                                                                    {currencyType[process.env.REACT_APP_CURRENCY]?.code}{" "}
                                                                    {state?.merchant?.shipping?.premium?.instate_price}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={4} sx={{ pl: 2 }}>
                                                                <Typography variant="caption">Out City</Typography>
                                                                <Typography variant="body2" mt={1.5}>
                                                                    {currencyType[process.env.REACT_APP_CURRENCY]?.code}{" "}
                                                                    {state?.merchant?.shipping?.premium?.outstate_price}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Grid>}

                                                {/* Express Shipping */}
                                                {state?.merchant?.shipping?.express?.days && <Grid item xs={12} md={4}>
                                                    <Box
                                                        sx={{
                                                            mb: 3,
                                                            borderBottom: "1px solid rgba(255,255,255,0.2)",
                                                            pb: "10px",

                                                        }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            sx={{ mb: 1, fontFamily: "Maven Pro, sans-serif", m: 2, mb: 0 }}
                                                        >
                                                            <strong>Express Shipping Price</strong>
                                                        </Typography>
                                                        <Grid container m={2} mb={0}>
                                                            <Grid
                                                                item
                                                                xs={4}
                                                                sx={{
                                                                    borderRight: "1px solid rgba(255,255,255,0.2)",
                                                                    pr: 2,
                                                                }}
                                                            >
                                                                <Typography variant="caption">Days</Typography>
                                                                <Typography variant="body2" mt={1.5}>
                                                                    {state?.merchant?.shipping?.express?.days}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid
                                                                item
                                                                xs={4}
                                                                sx={{
                                                                    borderRight: "1px solid rgba(255,255,255,0.2)",
                                                                    px: 2,
                                                                }}
                                                            >
                                                                <Typography variant="caption">In City</Typography>
                                                                <Typography variant="body2" mt={1.5}>
                                                                    {currencyType[process.env.REACT_APP_CURRENCY]?.code}{" "}
                                                                    {state?.merchant?.shipping?.express?.instate_price}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={4} sx={{ pl: 2 }}>
                                                                <Typography variant="caption">Out City</Typography>
                                                                <Typography variant="body2" mt={1.5}>
                                                                    {currencyType[process.env.REACT_APP_CURRENCY]?.code}{" "}
                                                                    {state?.merchant?.shipping?.express?.outstate_price}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Grid>}
                                            </Grid>
                                            <Grid
                                                container
                                                spacing={0}
                                                sx={{
                                                    mb: 0,


                                                }}
                                            >

                                                <Grid
                                                    item
                                                    xs={6}
                                                    md={6}
                                                    sx={{

                                                        p: 2,

                                                        pb: 0,

                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{ fontFamily: "Maven Pro, sans-serif " }}
                                                    >
                                                        <strong>Printing Methods</strong>
                                                    </Typography>

                                                    <Typography
                                                        variant="body2"
                                                        sx={{ mt: 1, fontFamily: "Maven Pro, sans-serif " }}
                                                    >
                                                        {state?.merchant?.printing_methods?.length > 0 &&
                                                            state.merchant.printing_methods
                                                                .map((method) => method?.name ?? method)
                                                                .join(", ")}
                                                    </Typography>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={6}
                                                    md={6}
                                                    sx={{

                                                        p: 2,

                                                        pb: 0,

                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{ fontFamily: "Maven Pro, sans-serif " }}
                                                    >
                                                        <strong>Social Media Links</strong>
                                                    </Typography>

                                                    <Grid container spacing={1} sx={{ mt: 0 }}>
                                                        {state?.merchant?.social_medias?.map((link, index) => (
                                                            <Grid
                                                                item
                                                                xs={4}
                                                                sm={2}
                                                                md={2}
                                                                key={index}
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",


                                                                }}
                                                            >
                                                                {/* Icon */}
                                                                <Box
                                                                    component={'div'}
                                                                    onClick={() => window.open(link.link, '_blank')}

                                                                    sx={{
                                                                        fontSize: "22px",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        cursor: 'pointer'
                                                                    }}
                                                                >
                                                                    {platformIcons[link?.type?.toLowerCase?.()]}
                                                                </Box>


                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            {/* Standard Prices */}




                                            {/* Buttons */}
                                            {/* <Box >

                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    onClick={() => {
                                                        localStorage.setItem("merchant", JSON.stringify(state?.merchant));
                                                        navigate("/cart", {
                                                            state: { merchant: state?.merchant }, // ✅ provide key properly
                                                        })
                                                    }
                                                    }

                                                    sx={{
                                                        bgcolor: "#0BD1D1",
                                                        border: "1px solid #0BD1D1",   // ✅ correct way
                                                        color: "#101A33",
                                                        fontWeight: 700,
                                                        width: '60%',
                                                        "&:hover": {
                                                            bgcolor: "#0BD1D1", // softer hover bg
                                                            border: "1px solid #0BD1D1",        // change border color on hover
                                                            color: "#101A33",                   // optional: change text color too
                                                        },
                                                        flex: 1,
                                                        fontFamily: "Maven Pro, sans-serif",
                                                        textTransform: "capitalize",
                                                        borderRadius: "12px",  // ✅ add rounded corners if you want
                                                        padding: "6px 16px",  // ✅ better button spacing
                                                    }}
                                                >
                                                    Proceed  Order With This Merchant
                                                </Button>
                                            </Box> */}
                                        </Grid>

                                        {/* RIGHT SIDE (Images) */}
                                        <Grid item xs={12} md={12} >
                                            <Grid container spacing={2}>


                                                {/* RIGHT SIDE (Main + 2 smaller images) */}
                                                <Grid item xs={12}>
                                                    {/* Main Image */}
                                                    {/* <Box sx={{ mb: 2, position: "relative", height: 530 }}>
                                                        {!loaded[0] && (
                                                            <Box
                                                                sx={{
                                                                    position: "absolute",
                                                                    inset: 0,
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    bgcolor: "#0f1a25",
                                                                    borderRadius: "8px",
                                                                }}
                                                            >
                                                                <Box component={'img'} src={Images.loader} width={'100px'} />
                                                            </Box>
                                                        )}

                                                        <CardMedia
                                                            component="img"
                                                            height="530"
                                                            image={images[0]}
                                                            alt="Main"
                                                            sx={{
                                                                borderRadius: "8px",
                                                                cursor: "pointer",
                                                                display: loaded[0] ? "block" : "none",
                                                            }}
                                                            onClick={() => {
                                                                setPhotoIndex(0);
                                                                setIsOpen(true);
                                                            }}
                                                            onLoad={() => handleImageLoad(0)}
                                                        />
                                                    </Box> */}

                                                    {/* Additional Images */}
                                                    <Grid container spacing={2}>
                                                        {images.map((img, index) => {
                                                            const realIndex = index + 1;
                                                            return (
                                                                <Grid item xs={4} sm={4} md={2.4} key={realIndex} sx={{ position: "relative" }}>
                                                                    {!loaded[realIndex] && (
                                                                        <Box
                                                                            sx={{
                                                                                position: "absolute",
                                                                                inset: 0,
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                alignItems: "center",
                                                                                // bgcolor: "#0f1a25",
                                                                                borderRadius: "8px",
                                                                                height: "170"
                                                                            }}
                                                                        >
                                                                            <Box component={'img'} mt={3} src={Images.loader} width={'100px'} />
                                                                        </Box>
                                                                    )}

                                                                    <CardMedia
                                                                        component="img"
                                                                        height="170"
                                                                        image={img}
                                                                        alt={`extra-${realIndex}`}
                                                                        sx={{
                                                                            borderRadius: "8px",
                                                                            cursor: "pointer",
                                                                            display: loaded[realIndex] ? "block" : "none",
                                                                        }}
                                                                        onClick={() => {
                                                                            setPhotoIndex(realIndex);
                                                                            setIsOpen(true);
                                                                        }}
                                                                        onLoad={() => handleImageLoad(realIndex)}
                                                                    />
                                                                </Grid>
                                                            );
                                                        })}
                                                    </Grid>

                                                    {/* Lightbox */}
                                                    {isOpen && (
                                                        <Lightbox
                                                            mainSrc={images[photoIndex]}
                                                            nextSrc={images[(photoIndex + 1) % images.length]}
                                                            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                                                            onCloseRequest={() => setIsOpen(false)}
                                                            onMovePrevRequest={() =>
                                                                setPhotoIndex((photoIndex + images.length - 1) % images.length)
                                                            }
                                                            onMoveNextRequest={() =>
                                                                setPhotoIndex((photoIndex + 1) % images.length)
                                                            }
                                                        />
                                                    )}
                                                    <Box p={2}>
                                                        {/* Main Heading */}
                                                        <Typography
                                                            variant="h6"
                                                            sx={{
                                                                mb: 3,
                                                                fontFamily: "Maven Pro, sans-serif",
                                                                fontWeight: 700,
                                                                color: "#fff",
                                                            }}
                                                        >
                                                            Fabric Selection
                                                        </Typography>

                                                        <Grid container spacing={4}>
                                                            {/* ===== STANDARD FABRICS COLUMN ===== */}
                                                            <Grid item xs={12} md={6}>
                                                                <Typography
                                                                    variant="h6"
                                                                    sx={{
                                                                        mb: 3,
                                                                        fontFamily: "Maven Pro, sans-serif",

                                                                        fontWeight: 700,
                                                                        color: "#fff",
                                                                    }}
                                                                >
                                                                    Standard
                                                                </Typography>
                                                                {/* Standard Prices */}
                                                                <Box sx={{ mb: 3, borderBottom: "1px solid rgba(255,255,255,0.2)", }}>
                                                                    <Typography
                                                                        variant="body2"
                                                                        sx={{ mb: 1, fontFamily: "Maven Pro, sans-serif" }}
                                                                    >
                                                                        <strong> Prices</strong>
                                                                    </Typography>
                                                                    <Grid container>
                                                                        <Grid
                                                                            item
                                                                            xs={4}
                                                                            sx={{
                                                                                borderRight: "1px solid rgba(255,255,255,0.2)",
                                                                                pr: 2,
                                                                            }}
                                                                        >
                                                                            <Typography variant="caption">One Side Print</Typography>
                                                                            <Typography variant="body2" mt={1.5}>
                                                                                {currencyType[process.env.REACT_APP_CURRENCY]?.code}{" "}
                                                                                {state?.merchant?.products?.[0]?.one_side_standard}
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid
                                                                            item
                                                                            xs={4}
                                                                            sx={{
                                                                                borderRight: "1px solid rgba(255,255,255,0.2)",
                                                                                px: 2,
                                                                            }}
                                                                        >
                                                                            <Typography variant="caption">Double Side Print</Typography>
                                                                            <Typography variant="body2" mt={1.5}>
                                                                                {currencyType[process.env.REACT_APP_CURRENCY]?.code}{" "}
                                                                                {state?.merchant?.products?.[0]?.double_side_standard}
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid item xs={4} sx={{ pl: 2 }}>
                                                                            <Typography variant="caption">Additional Image</Typography>
                                                                            <Typography variant="body2" mt={1.5}>
                                                                                {currencyType[process.env.REACT_APP_CURRENCY]?.code}{" "}
                                                                                {state?.merchant?.products?.[0]?.additional_standard}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Box>

                                                                {/* Standard Fabrics */}
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{ mb: 1, fontFamily: "Maven Pro, sans-serif" }}
                                                                >
                                                                    <strong> Fabrics</strong>
                                                                </Typography>

                                                                <RadioGroup
                                                                    row
                                                                    value={selectedFabric}
                                                                    onChange={(e) => setSelectedFabric(e.target.value)}
                                                                >
                                                                    <Grid container spacing={2}>
                                                                        {state?.merchant?.products?.[0]?.fabrics?.map((fabric, index) => (
                                                                            <Grid item xs={4} key={index}>
                                                                                <FormControlLabel
                                                                                    value={fabric?.name ?? fabric}
                                                                                    control={
                                                                                        <Radio
                                                                                            sx={{
                                                                                                color: "white",
                                                                                                transform: "scale(0.9)",
                                                                                                padding: "2px",
                                                                                            }}
                                                                                        />
                                                                                    }
                                                                                    label={fabric?.name ?? fabric}
                                                                                    sx={{
                                                                                        "& .MuiFormControlLabel-label": {
                                                                                            fontSize: "12px",
                                                                                            color: "white",
                                                                                            wordBreak:'break-all'
                                                                                        },
                                                                                    }}
                                                                                />
                                                                            </Grid>
                                                                        ))}
                                                                    </Grid>
                                                                </RadioGroup>
                                                            </Grid>

                                                            {/* ===== PREMIUM FABRICS COLUMN ===== */}
                                                            {state?.merchant?.products?.[0]?.premium_fabrics?.length > 0 && (
                                                                <Grid item xs={12} md={6}>
                                                                    <Typography
                                                                        variant="h6"
                                                                        sx={{
                                                                            mb: 3,
                                                                            fontFamily: "Maven Pro, sans-serif",
                                                                            fontWeight: 700,
                                                                            color: "#fff",
                                                                        }}
                                                                    >
                                                                        Premium
                                                                    </Typography>
                                                                    {/* Premium Prices */}
                                                                    <Box sx={{ mb: 3, borderBottom: "1px solid rgba(255,255,255,0.2)", }}>
                                                                        <Typography
                                                                            variant="body2"
                                                                            sx={{ mb: 1, fontFamily: "Maven Pro, sans-serif" }}
                                                                        >
                                                                            <strong> Prices</strong>
                                                                        </Typography>
                                                                        <Grid container>
                                                                            <Grid
                                                                                item
                                                                                xs={4}
                                                                                sx={{
                                                                                    borderRight: "1px solid rgba(255,255,255,0.2)",
                                                                                    pr: 2,
                                                                                }}
                                                                            >
                                                                                <Typography variant="caption">One Side Print</Typography>
                                                                                <Typography variant="body2" mt={1.5}>
                                                                                    {currencyType[process.env.REACT_APP_CURRENCY]?.code}{" "}
                                                                                    {state?.merchant?.products?.[0]?.one_side_premium}
                                                                                </Typography>
                                                                            </Grid>
                                                                            <Grid
                                                                                item
                                                                                xs={4}
                                                                                sx={{
                                                                                    borderRight: "1px solid rgba(255,255,255,0.2)",
                                                                                    px: 2,
                                                                                }}
                                                                            >
                                                                                <Typography variant="caption">Double Side Print</Typography>
                                                                                <Typography variant="body2" mt={1.5}>
                                                                                    {currencyType[process.env.REACT_APP_CURRENCY]?.code}{" "}
                                                                                    {state?.merchant?.products?.[0]?.double_side_premium}
                                                                                </Typography>
                                                                            </Grid>
                                                                            <Grid item xs={4} sx={{ pl: 2 }}>
                                                                                <Typography variant="caption">Additional Image</Typography>
                                                                                <Typography variant="body2" mt={1.5}>
                                                                                    {currencyType[process.env.REACT_APP_CURRENCY]?.code}{" "}
                                                                                    {state?.merchant?.products?.[0]?.additional_premium}
                                                                                </Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Box>

                                                                    {/* Premium Fabrics */}
                                                                    <Typography
                                                                        variant="body2"
                                                                        sx={{ mb: 1, fontFamily: "Maven Pro, sans-serif" }}
                                                                    >
                                                                        <strong> Fabrics</strong>
                                                                    </Typography>

                                                                    <RadioGroup
                                                                        row
                                                                        value={selectedFabric}
                                                                        onChange={(e) => setSelectedFabric(e.target.value)}
                                                                    >
                                                                        <Grid container spacing={2}>
                                                                            {state?.merchant?.products?.[0]?.premium_fabrics?.map(
                                                                                (fabric, index) => (
                                                                                    <Grid item xs={4} key={index}>
                                                                                        <FormControlLabel
                                                                                            value={fabric?.name ?? fabric}
                                                                                            control={
                                                                                                <Radio
                                                                                                    sx={{
                                                                                                        color: "white",
                                                                                                        transform: "scale(0.9)",
                                                                                                        padding: "2px",
                                                                                                    }}
                                                                                                />
                                                                                            }
                                                                                            label={fabric?.name ?? fabric}
                                                                                            sx={{
                                                                                                "& .MuiFormControlLabel-label": {
                                                                                                    fontSize: "12px",
                                                                                                    color: "white",
                                                                                                     wordBreak:'break-all'
                                                                                                },
                                                                                            }}
                                                                                        />
                                                                                    </Grid>
                                                                                )
                                                                            )}
                                                                        </Grid>
                                                                    </RadioGroup>
                                                                </Grid>
                                                            )}
                                                        </Grid>

                                                        {/* ===== Place Order Button ===== */}
                                                        <Grid container justifyContent="center" mt={4}>
                                                            <Grid item xs={12} md={6} display="flex" justifyContent="center">
                                                                <Button
                                                                    variant="contained"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        UpdateCart(state?.merchant, selectedFabric);
                                                                    }}
                                                                    sx={{
                                                                        bgcolor: "transparent",
                                                                        border: "1px solid #0BD1D1",
                                                                        color: "#0BD1D1",
                                                                        fontWeight: 700,
                                                                        width: "100%",
                                                                        maxWidth: 300, // optional: keeps button from stretching too wide
                                                                        fontFamily: "Maven Pro, sans-serif",
                                                                        textTransform: "capitalize",
                                                                        borderRadius: "12px",
                                                                        padding: "6px 16px",
                                                                    }}
                                                                >
                                                                    Place Order
                                                                </Button>
                                                            </Grid>
                                                        </Grid>

                                                    </Box>


                                                </Grid>
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                </Card>
                            </Grid>

                        </Grid>
                        <Container maxWidth="lg" sx={{ mt: 6, mb: 6 }}>
                            <Grid container spacing={2}>
                                {/* LEFT SIDE */}
                                <Grid item xs={12} md={12}>
                                    {/* Description */}
                                    <Typography
                                        variant="h5"
                                        className="banner-text heading-font"
                                        sx={{ mb: 2, fontWeight: "bold", color: "white", fontFamily: "Maven Pro, sans-serif" }}
                                    >
                                        Description
                                    </Typography>
                                    <Typography variant="body2" sx={{ mb: 3, color: "rgba(255,255,255,0.8)" }}>
                                        {state?.merchant?.business_description}
                                    </Typography>
                                    <Typography
                                        variant="h5"
                                        className="banner-text heading-font"
                                        sx={{ mb: 2, fontWeight: "bold", color: "white", fontFamily: "Maven Pro, sans-serif" }}
                                    >
                                        Size Chart
                                    </Typography>
                                    {/* Size Chart */}
                                    <Box
                                        sx={{
                                            border: "1px solid #0bd1d1",
                                            borderRadius: "12px",
                                            overflow: "hidden", // ✅ ensures rounded corners are applied
                                            mb: 3,
                                            p: 1.5
                                        }}
                                    >
                                        <table style={{ width: "100%", borderCollapse: "collapse", color: "white", }} >
                                            <thead>
                                                <tr > <th style={{ padding: "10px", textAlign: "left", fontFamily: "Maven Pro, sans-serif" }}>Size</th> <th style={{ padding: "10px", textAlign: "left", fontFamily: "Maven Pro, sans-serif" }}>Chest</th> <th style={{ padding: "10px", textAlign: "left", fontFamily: "Maven Pro, sans-serif" }}>Length</th> <th style={{ padding: "10px", textAlign: "left", fontFamily: "Maven Pro, sans-serif" }}>Shoulder</th> </tr> </thead>

                                            <tbody>
                                                {state?.merchant?.products[0]?.size_chart?.length > 0 &&
                                                    state?.merchant?.products[0]?.size_chart?.map((row, i) => (
                                                        <tr
                                                            key={i}
                                                            style={{ borderTop: "1px solid rgba(255,255,255,0.2)" }}
                                                        >
                                                            {/* Map over the values of each object */}
                                                            {Object.values(row).map((col, j) => (
                                                                <td key={j} style={{ padding: "10px", fontSize: "14px" }}>
                                                                    {col}
                                                                </td>
                                                            ))}
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </Box>


                                    {/* Social Media */}

                                </Grid>



                                {/* RIGHT SIDE */}

                            </Grid>
                        </Container>

                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

export default MerchantDetail
